import { Button } from '@/components/ui/Button';
import { ComponentClinicProps } from '@/types/components';
import { getImageSizes } from '@/utils/tailwind';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { Doctor } from './Doctor';

export function Clinic(props: ComponentClinicProps) {
  const t = useTranslations('components.Clinic');
  const {
    name,
    slug,
    address,
    description,
    image,
    telephone,
    openingHours,
    doctors,
  } = props;
  return (
    <>
      <div className='rounded-2xl bg-white shadow'>
        <div className='relative aspect-video w-full'>
          {image && (
            <Image
              src={image.url}
              alt={name ?? image.alt ?? ''}
              fill
              sizes={getImageSizes(
                [
                  ['xl', '100vw'],
                  ['2xl', '50vw'],
                ],
                '33vw'
              )}
              className='rounded-t-2xl object-cover'
            />
          )}
        </div>
        <div className='px-5 py-6 md:px-10 md:py-12'>
          <div className='grid grid-rows-[minmax(180px,auto)_auto] gap-6 md:grid-rows-[minmax(260px,auto)_auto] lg:grid-rows-[minmax(300px,auto)_auto]'>
            <div className='h-full text-xs md:text-lg'>
              <h3 className='sh-heading-3 mb-2 md:mb-5'>{name}</h3>
              {description && (
                <p className='sh-body mb-2 md:mb-5'>{description}</p>
              )}
              {address && <p className='sh-body'>{address}</p>}
              {telephone && (
                <p>
                  Tel:{' '}
                  <a className='sh-body' href={`tel:${telephone}`}>
                    {telephone}
                  </a>
                </p>
              )}
              {openingHours && <p className='sh-body'>{openingHours}</p>}
            </div>
            <div className='space-y-5 md:space-y-10'>
              {Array.isArray(doctors) && doctors.length > 0 && (
                <div>
                  <h4 className='sh-heading-3 mb-5'>{t('meetOurDoctors')}</h4>
                  <ul className='grid grid-cols-2 gap-5'>
                    {doctors.map(doctor => (
                      <li key={doctor.id}>
                        <Doctor {...doctor} />
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              <Button variant='dark' href={`/locations/${slug}`}>
                {t('viewClinic')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
